export default defineNuxtPlugin((nuxtApp) => {
  const logError = async (err, info) => {
    const isError = err instanceof Error;
    try {
      await fetch('/api/error/log', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: isError ? err.message : String(err),
          stack: isError ? err.stack : undefined,
          info,
          url: window.location.href,
          userAgent: navigator.userAgent,
          time: new Date().toISOString(),
        }),
      });
    } catch (e) {
      console.error('Failed to log frontend error:', e);
    }
  };

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error(err, info);
    logError(err, info);

    // Errors created via createError() (e.g. the 404 thrown for an invalid
    // catalog URL) are meant to render the app's error.vue page. Vue's
    // global errorHandler intercepts them before Nuxt's own error pipeline
    // sees them, so without this they'd just get logged and the page would
    // silently stay blank/stale instead of showing the error screen.
    if (err?.statusCode) {
      nuxtApp.runWithContext(() => showError(err));
    }
  };

  // Non-capturing: only catches uncaught script errors, not resource
  // load failures (img/script tags), which don't bubble to window.
  // The event.target check below is a second guard against the same
  // thing: if this listener is ever switched to capture:true (which
  // WOULD see resource errors, since those propagate in the capture
  // phase), we still don't want every missing image/icon reported as
  // an app error, so bail out on anything not dispatched on window
  // itself.
  window.addEventListener('error', (event) => {
    if (event.target !== window) return;
    const err = event.error ?? new Error(event.message);
    console.error(err);
    logError(err, 'window.onerror');
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error(event.reason);
    logError(event.reason, 'unhandledrejection');
  });
});
